
//export const url = "//localhost:9001";
//export const url = "//test.uren-boeken.nl/Admin";
export const url = "//uren-boeken.nl/Admin";

export const maxActivityLength = 9;
